module.exports = __webpack_public_path__ + "static/media/template.7cb0c302.svg";